import { render } from "./BlockSimple.vue?vue&type=template&id=67410d08&scoped=true"
import script from "./BlockSimple.vue?vue&type=script&lang=js"
export * from "./BlockSimple.vue?vue&type=script&lang=js"

import "./BlockSimple.vue?vue&type=style&index=0&id=67410d08&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67410d08"]])

export default __exports__